export default __webpack_public_path__ + "static/media/1.023f9aa5.jpg";